export const extractAddressDetails = (selectedPlace: google.maps.places.PlaceResult) => {
  const { geometry, formatted_address } = selectedPlace;
  const addressComponents = selectedPlace.address_components;

  const findByType = (type: string | string[]) =>
    addressComponents?.find((item) =>
      Array.isArray(type) ? type.some((t) => item.types.includes(t)) : item.types.includes(type)
    );

  const state = findByType('administrative_area_level_1')?.short_name || '';
  const city = findByType(['administrative_area_level_2', 'administrative_area_level_3'])?.long_name || '';
  const postal_code = findByType('postal_code')?.long_name || '';
  const premise = findByType('premise')?.long_name || '';
  const street_number = findByType('street_number')?.long_name || '';
  const route = findByType('route')?.long_name || '';
  const locality = findByType('locality')?.long_name || '';

  const address_street = [premise, street_number, route, locality]
    .filter((value) => value) // Filter out undefined or empty values
    .join(', ');

  const latitude = geometry?.location?.lat();
  const longitude = geometry?.location?.lng();

  return {
    formatted_address,
    longitude,
    latitude,
    state,
    city,
    postal_code,
    premise,
    street_number,
    route,
    locality,
    address_street,
  };  
}